(function initNewCalendarRenderer() {
  const CALENDAR_PAGE_CACHE_STORAGE_PREFIX = 'calendar-page-cache-v1.';
  const CALENDAR_CART_PREVIEW_STORAGE_KEY = 'calendar-cart-preview-by-assignment-offer-id-v1';

  function stripEmojisAndSpecialChars(str) {
    if (!str) return '';

    // Step 1 — remove emojis
    const noEmojis = str.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\u24C2-\uF251]|[\uD83C-\uDBFF][\uDC00-\uDFFF])/g,
      ''
    );

    // Step 2 — remove special characters (keep A–Z, a–z, 0–9, spaces)
    const cleaned = noEmojis.replace(/[^a-zA-Z0-9 ]+/g, '');

    return cleaned.trim();
  }

  function normalizeCalendarText(str) {
    return stripEmojisAndSpecialChars(String(str || ''))
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function extractMonthYearPairs(normalizedText) {
    if (!normalizedText) {
      return [];
    }

    const monthNames =
      '(january|february|march|april|may|june|july|august|september|october|november|december)';
    const monthYearRegex = new RegExp(`${monthNames}\\s+(\\d{4})`, 'g');
    const pairs = [];
    let match = monthYearRegex.exec(normalizedText);

    while (match) {
      pairs.push(`${match[1]} ${match[2]}`);
      if (pairs.length >= 2) {
        break;
      }
      match = monthYearRegex.exec(normalizedText);
    }

    return pairs;
  }

  function extractPetType(normalizedText) {
    if (!normalizedText) {
      return '';
    }

    if (normalizedText.includes('cat')) {
      return 'cat';
    }

    if (normalizedText.includes('dog')) {
      return 'dog';
    }

    return '';
  }

  function doesCalendarIdentityMatch(productTitle, calendarName) {
    const normalizedProductTitle = normalizeCalendarText(productTitle);
    const normalizedCalendarName = normalizeCalendarText(calendarName);

    const productMonthYears = extractMonthYearPairs(normalizedProductTitle);
    const calendarMonthYears = extractMonthYearPairs(normalizedCalendarName);

    if (productMonthYears.length < 2 || calendarMonthYears.length < 2) {
      return false;
    }

    const monthYearMatch =
      productMonthYears[0] === calendarMonthYears[0] &&
      productMonthYears[1] === calendarMonthYears[1];

    if (!monthYearMatch) {
      return false;
    }

    const productPetType = extractPetType(normalizedProductTitle);
    const calendarPetType = extractPetType(normalizedCalendarName);

    if (!productPetType || !calendarPetType) {
      return false;
    }

    return productPetType === calendarPetType;
  }

  function renderNewCalendarOffer({
    assignmentOffer,
    tableSelector,
    offerAssembly,
  } = {}) {
    if (!assignmentOffer) {
      return;
    }

    const mediaGallery =
      document.querySelector('.main-product__media-gallery') || document.querySelector('.ProductMediaWrapper') || document.querySelector('.gp-featured-image-wrapper');
    const calendarGridContainer = document.querySelector('.calendar-grid');
    const table = document.querySelector(tableSelector);

    const pages = assignmentOffer.calendar.pages.filter((page) => page.type == 'submission_insert');
    const viewerCalendarPages = pages.filter((page) => getCalendarImageUrlFromPage(page));
    const viewerCalendarPageUrls = viewerCalendarPages.map(getCalendarImageUrlFromPage);
    const viewerPageIndex = findViewerCalendarPageIndexWithFallback(viewerCalendarPages, assignmentOffer.personalized_page_position);
    const mockupCalendarImageUrls = getMockupCalendarImageUrls(viewerCalendarPageUrls, viewerPageIndex);
    const firstCalendarImageUrl = mockupCalendarImageUrls[0] || '';
    const secondCalendarImageUrl = mockupCalendarImageUrls[1] || '';
    const thirdCalendarImageUrl = mockupCalendarImageUrls[2] || '';

    resolveCachedCalendarPageUrls({
      assignmentOffer,
      imageUrls: mockupCalendarImageUrls,
    })
      .then((cachedImageUrls) => {
        const firstMockupSourceUrl = cachedImageUrls[0] || firstCalendarImageUrl;
        const secondMockupSourceUrl = cachedImageUrls[1] || secondCalendarImageUrl;
        const thirdMockupSourceUrl = cachedImageUrls[2] || thirdCalendarImageUrl;

        if (viewerPageIndex >= 0) {
          const resolvedViewerImageUrl = cachedImageUrls[0] || viewerCalendarPageUrls[viewerPageIndex] || '';
          setCalendarCartPreviewUrl(getAssignmentOfferCacheId(assignmentOffer), resolvedViewerImageUrl);
        }

        updateCalendarMockupImage({
          imageUrl: firstMockupSourceUrl,
          mockupSelector: '.calendar-mockup-1',
          transformationName: 't_calendar-mockup-1',
        });
        updateCalendarMockupImage({
          imageUrl: secondMockupSourceUrl,
          mockupSelector: '.calendar-mockup-2',
          transformationName: 't_calendar-mockup-2',
        });
        updateCalendarMockupImage({
          imageUrl: thirdMockupSourceUrl,
          mockupSelector: '.calendar-mockup-3',
          transformationName: 't_calendar-mockup-3',
        });
        initCalendarMockupLightbox();
      })
      .catch(() => {
        if (viewerPageIndex >= 0) {
          setCalendarCartPreviewUrl(getAssignmentOfferCacheId(assignmentOffer), viewerCalendarPageUrls[viewerPageIndex] || '');
        }

        updateCalendarMockupImage({
          imageUrl: firstCalendarImageUrl,
          mockupSelector: '.calendar-mockup-1',
          transformationName: 't_calendar-mockup-1',
        });
        updateCalendarMockupImage({
          imageUrl: secondCalendarImageUrl,
          mockupSelector: '.calendar-mockup-2',
          transformationName: 't_calendar-mockup-2',
        });
        updateCalendarMockupImage({
          imageUrl: thirdCalendarImageUrl,
          mockupSelector: '.calendar-mockup-3',
          transformationName: 't_calendar-mockup-3',
        });
        initCalendarMockupLightbox();
      });

    const productNameEl =
      document.querySelector('.main-product__blocks h1') ||
      document.querySelector('gp-product-title h1') ||
      document.querySelector('.pf-heading-1-h1') ||
      document.querySelector('.product-title');

    const productName = productNameEl ? productNameEl.innerHTML.trim() : '';
    const responseName = assignmentOffer?.calendar?.name || '';

    if (doesCalendarIdentityMatch(productName, responseName)) {
      const calendarUrl = new URL(window.location.href);
      const dogId = assignmentOffer.submission?.dog_id || window._pet_data?.dog_id || localStorage.getItem('dog_id');
      const offerId = getAssignmentOfferCacheId(assignmentOffer);
      if (!calendarUrl.searchParams.get('r')?.includes('|') && dogId && offerId) {
        calendarUrl.searchParams.set('r', `${dogId}|${offerId}`);
      }
      localStorage.setItem('c-url', calendarUrl.href);

      if (typeof window.addCalendarToMenuIfNeeded === 'function') {
        window.addCalendarToMenuIfNeeded();
      }
    }

    var cellCount = 0;

    for (var i = 0; i < table.rows.length; i++) {
      for (var j = 0; j < table.rows[i].cells.length; j++) {
        const imageUrl = getCalendarImageUrlFromPage(pages[cellCount]);
        const lightHouseImageUrls = {
          189: pages[cellCount].urls
            ? pages[cellCount].urls.calendar_compressed_189
            : pages[cellCount].default_web_url,
          400: pages[cellCount].urls
            ? pages[cellCount].urls.calendar_compressed_400
            : pages[cellCount].default_web_url,
          600: pages[cellCount].urls
            ? pages[cellCount].urls.calendar_compressed_600
            : pages[cellCount].default_web_url,
          1000: pages[cellCount].urls
            ? pages[cellCount].urls.calendar_compressed_1000
            : pages[cellCount].default_web_url,
        };

        var imageElement = table.rows[i].cells[j].querySelector('img');

        imageElement.src = '';
        imageElement.src = imageUrl;
        imageElement.fetchPriority = 'high';
        imageElement.style.padding = '5px';
        imageElement.width = '245';
        imageElement.height = '189';
        imageElement.dataset.sizes = '(max-width: 189px) 189px, (max-width: 400px) 400px, 600px';
        imageElement.dataset.srcset = `${lightHouseImageUrls['189']} 189w, ${lightHouseImageUrls['400']} 400w, ${lightHouseImageUrls['600']} 600w`;

        const aTag = document.createElement('a');
        aTag.href = imageUrl;
        aTag.dataset.type = 'image';
        aTag.dataset.gallery = 'calendar-gallery';
        aTag.classList.add('glightbox');
        aTag.dataset.sizes = '(max-width: 189px) 189px, (max-width: 400px) 400px, 600px';
        aTag.dataset.srcset = `${lightHouseImageUrls['189']} 189w, ${lightHouseImageUrls['400']} 400w, ${lightHouseImageUrls['600']} 600w`;
        aTag.onclick = function () {
          console.log('Clicked');
          return false;
        };
        aTag.appendChild(imageElement);

        table.rows[i].cells[j].appendChild(aTag);

        cellCount++;
      }
    }

    table.style.display = 'block';

    const shouldUseCarousel = shouldShowAssemblyCarousel(offerAssembly);

    if (document.querySelector('.p-description-show-more')) {
      document.querySelector('.p-description-show-more').style.display = 'none';
    }

    // On some sales pages, preserve the existing gallery image and render the table in the dedicated GP row.
    if (calendarGridContainer) {
      calendarGridContainer.replaceChildren();
      calendarGridContainer.appendChild(table);
    } else {
      // Not necessary but setting a very short timeout will buffer any choppiness in loading the table
      mediaGallery.innerHTML = '';
      if (shouldUseCarousel) {
        const carousel = buildCalendarCarousel({
          assemblyImageUrl: offerAssembly.file_url,
          tableElement: table,
        });
        mediaGallery.appendChild(carousel);
      } else {
        mediaGallery.appendChild(table);
      }
    }

    GLightbox({
      touchNavigation: true,
      loop: true,
      selector: '.main-product__media-gallery a.glightbox[data-gallery="calendar-gallery"]',
    });
    GLightbox({
      touchNavigation: true,
      loop: true,
      selector: '.ProductMediaWrapper a.glightbox[data-gallery="calendar-gallery"]',
    });
    GLightbox({
      touchNavigation: true,
      loop: true,
      selector: '.gp-featured-image-wrapper a.glightbox[data-gallery="calendar-gallery"]',
    });
    GLightbox({
      touchNavigation: true,
      loop: true,
      selector: '.calendar-grid a.glightbox[data-gallery="calendar-gallery"]',
    });
  }

  window.renderNewCalendarOffer = renderNewCalendarOffer;

  function getCalendarImageUrlFromPage(page) {
    if (!page) {
      return '';
    }

    return page.urls ? page.urls.calendar_compressed : page.default_web_url;
  }

  function getViewerPetImageCandidates() {
    const petData = window._pet_data || {};
    return {
      imageUrl: petData.image_url || '',
      originalImageUrl: petData.original_image_url || '',
    };
  }

  function findViewerCalendarPageIndex(pageUrls, viewerImageUrl) {
    if (!viewerImageUrl || !Array.isArray(pageUrls) || !pageUrls.length) {
      return -1;
    }

    const normalizedViewerUrl = String(viewerImageUrl).trim();
    if (!normalizedViewerUrl) {
      return -1;
    }

    const encodedViewerUrl = encodeURIComponent(normalizedViewerUrl);
    const doubleEncodedViewerUrl = encodeURIComponent(encodedViewerUrl);

    return pageUrls.findIndex((pageUrl) => {
      if (!pageUrl || typeof pageUrl !== 'string') {
        return false;
      }

      if (
        pageUrl.includes(normalizedViewerUrl) ||
        pageUrl.includes(encodedViewerUrl) ||
        pageUrl.includes(doubleEncodedViewerUrl)
      ) {
        return true;
      }

      try {
        const decoded = decodeURIComponent(pageUrl);
        return decoded.includes(normalizedViewerUrl) || decoded.includes(encodedViewerUrl);
      } catch (error) {
        return false;
      }
    });
  }

  function findViewerCalendarPageIndexWithFallback(pages, personalizedPagePosition) {
    if (Number.isInteger(personalizedPagePosition)) {
      return pages.findIndex((page) => page.position === personalizedPagePosition);
    }

    const pageUrls = pages.map(getCalendarImageUrlFromPage);
    const { imageUrl, originalImageUrl } = getViewerPetImageCandidates();
    const imageUrlMatchIndex = findViewerCalendarPageIndex(pageUrls, imageUrl);

    if (imageUrlMatchIndex >= 0) {
      return imageUrlMatchIndex;
    }

    return findViewerCalendarPageIndex(pageUrls, originalImageUrl);
  }

  function getMockupCalendarImageUrls(pageUrls, viewerPageIndex) {
    if (!pageUrls.length) {
      return [];
    }

    const fallbackUrls = pageUrls.slice(0, 3);
    if (viewerPageIndex < 0) {
      return fallbackUrls;
    }

    const orderedUrls = [];
    const targetCount = Math.min(3, pageUrls.length);
    for (let i = 0; i < targetCount; i++) {
      const index = (viewerPageIndex + i) % pageUrls.length;
      orderedUrls.push(pageUrls[index]);
    }

    return orderedUrls.length ? orderedUrls : fallbackUrls;
  }

  function getAssignmentOfferCacheId(assignmentOffer) {
    return (
      assignmentOffer?.id ||
      assignmentOffer?.assignment_offer_id ||
      localStorage.getItem('url_assignment_offer_id') ||
      ''
    );
  }

  function getCalendarPageCacheStorageKey(assignmentOfferCacheId) {
    return `${CALENDAR_PAGE_CACHE_STORAGE_PREFIX}${assignmentOfferCacheId}`;
  }

  function getCalendarCartPreviewMap() {
    try {
      const parsed = JSON.parse(localStorage.getItem(CALENDAR_CART_PREVIEW_STORAGE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function setCalendarCartPreviewUrl(assignmentOfferCacheId, imageUrl) {
    if (!assignmentOfferCacheId || !imageUrl) {
      return;
    }

    try {
      const previewMap = getCalendarCartPreviewMap();
      previewMap[String(assignmentOfferCacheId)] = String(imageUrl);
      localStorage.setItem(CALENDAR_CART_PREVIEW_STORAGE_KEY, JSON.stringify(previewMap));
    } catch (error) {
      console.error('Failed to cache calendar cart preview image', error);
    }
  }

  function getCachedCalendarPageUrls(assignmentOfferCacheId) {
    if (!assignmentOfferCacheId) {
      return [];
    }

    try {
      const storageKey = getCalendarPageCacheStorageKey(assignmentOfferCacheId);
      const parsed = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (!Array.isArray(parsed)) {
        return [];
      }

      return parsed.filter((url) => typeof url === 'string' && url.length > 0);
    } catch (error) {
      return [];
    }
  }

  function setCachedCalendarPageUrls(assignmentOfferCacheId, urls) {
    if (!assignmentOfferCacheId || !Array.isArray(urls) || urls.length === 0) {
      return;
    }

    const validUrls = urls.filter((url) => typeof url === 'string' && url.length > 0);
    if (!validUrls.length) {
      return;
    }

    try {
      const storageKey = getCalendarPageCacheStorageKey(assignmentOfferCacheId);
      localStorage.setItem(storageKey, JSON.stringify(validUrls));
    } catch (error) {
      console.error('Failed to cache calendar page urls', error);
    }
  }

  async function cacheCalendarPageUrls(imageUrls) {
    const validUrls = Array.isArray(imageUrls) ? imageUrls.filter((url) => typeof url === 'string' && url.length > 0) : [];
    if (!validUrls.length) {
      return [];
    }

    const config = window.pawPrintConfig || {};
    const endpoint = config.calendarImageCacheUrl;
    const authToken = config.calendarImageCacheAuth || config.latestOfferAssemblyAuth || '';

    if (!endpoint || !authToken) {
      return [];
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        auth: authToken,
      },
      body: JSON.stringify({
        image_urls: validUrls,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to cache calendar pages (${response.status})`);
    }

    const payload = await response.json();
    const urls = payload?.data?.urls;

    if (!Array.isArray(urls)) {
      return [];
    }

    return urls.filter((url) => typeof url === 'string' && url.length > 0);
  }

  async function resolveCachedCalendarPageUrls({ assignmentOffer, imageUrls } = {}) {
    const validUrls = Array.isArray(imageUrls) ? imageUrls.filter((url) => typeof url === 'string' && url.length > 0) : [];
    if (!validUrls.length) {
      return [];
    }

    const assignmentOfferCacheId = getAssignmentOfferCacheId(assignmentOffer);
    const cachedUrls = getCachedCalendarPageUrls(assignmentOfferCacheId);
    if (cachedUrls.length >= validUrls.length) {
      return cachedUrls.slice(0, validUrls.length);
    }

    const fetchedUrls = await cacheCalendarPageUrls(validUrls);
    if (fetchedUrls.length) {
      setCachedCalendarPageUrls(assignmentOfferCacheId, fetchedUrls);
      return fetchedUrls.slice(0, validUrls.length);
    }

    return cachedUrls.slice(0, validUrls.length);
  }

  function updateCalendarMockupImage({ imageUrl, mockupSelector, transformationName } = {}) {
    if (!imageUrl || !mockupSelector || !transformationName) {
      return;
    }

    const mockupContainers = document.querySelectorAll(mockupSelector);
    if (!mockupContainers.length) {
      return;
    }

    const mockupUrl =
      `https://res.cloudinary.com/da9yd4bgx/image/fetch/${transformationName}/f_webp/h_360/q_90/` + encodeURIComponent(imageUrl);

    mockupContainers.forEach((mockupContainer) => {
      const picture = mockupContainer.querySelector('picture');
      let img = mockupContainer.querySelector('img');

      // Keep img at the same DOM level as picture's parent and remove picture wrapper.
      if (picture && img && picture.parentElement) {
        picture.parentElement.insertBefore(img, picture);
        picture.remove();
      }

      img = mockupContainer.querySelector('img');
      if (!img) {
        return;
      }

      img.src = mockupUrl;
      img.setAttribute('srcset', mockupUrl);

      const existingAnchor = img.closest('a');
      if (existingAnchor) {
        existingAnchor.href = mockupUrl;
        existingAnchor.dataset.type = 'image';
        existingAnchor.dataset.gallery = 'calendar-mockup-gallery';
        existingAnchor.classList.add('glightbox', 'calendar-mockup-lightbox');
      } else if (img.parentElement) {
        const anchor = document.createElement('a');
        anchor.href = mockupUrl;
        anchor.dataset.type = 'image';
        anchor.dataset.gallery = 'calendar-mockup-gallery';
        anchor.classList.add('glightbox', 'calendar-mockup-lightbox');
        img.parentElement.insertBefore(anchor, img);
        anchor.appendChild(img);
      }
    });
  }

  function initCalendarMockupLightbox() {
    if (window._calendarMockupLightbox && typeof window._calendarMockupLightbox.destroy === 'function') {
      window._calendarMockupLightbox.destroy();
    }

    window._calendarMockupLightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      selector: 'a.calendar-mockup-lightbox[data-gallery="calendar-mockup-gallery"]',
    });
  }

  function shouldShowAssemblyCarousel(offerAssembly) {
    const allowlist = window.pawPrintConfig?.calendarAssemblyCarouselUrlAllowlist || [];
    if (!offerAssembly || !offerAssembly.file_url || !allowlist.length) {
      return false;
    }

    const currentPath = window.location.pathname || window.location.href;
    return allowlist.some((pathFragment) => currentPath.indexOf(pathFragment) > -1);
  }

  function buildCalendarCarousel({ assemblyImageUrl, tableElement } = {}) {
    const carousel = document.createElement('div');
    carousel.className = 'tpp-calendar-carousel';

    const track = document.createElement('div');
    track.className = 'tpp-calendar-carousel__track';

    const slideAssembly = document.createElement('div');
    slideAssembly.className = 'tpp-calendar-carousel__slide';

    const assemblyImage = document.createElement('img');
    assemblyImage.className = 'tpp-calendar-carousel__image';
    const assemblyLightboxUrl =
      'https://res.cloudinary.com/da9yd4bgx/image/fetch/f_jpg/w_1080/' + encodeURIComponent(assemblyImageUrl);
    assemblyImage.src = assemblyLightboxUrl;
    assemblyImage.alt = 'Calendar preview';
    assemblyImage.loading = 'eager';

    const assemblyLink = document.createElement('a');
    assemblyLink.href = assemblyLightboxUrl;
    assemblyLink.dataset.type = 'image';
    assemblyLink.dataset.gallery = 'calendar-gallery';
    assemblyLink.classList.add('glightbox');
    assemblyLink.appendChild(assemblyImage);

    slideAssembly.appendChild(assemblyLink);

    const slideGrid = document.createElement('div');
    slideGrid.className = 'tpp-calendar-carousel__slide';
    slideGrid.appendChild(tableElement);

    track.appendChild(slideAssembly);
    track.appendChild(slideGrid);

    const dots = document.createElement('div');
    dots.className = 'tpp-calendar-carousel__dots';

    const dotButtons = [0, 1].map((index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tpp-calendar-carousel__dot';
      dot.dataset.index = index;
      dot.setAttribute('aria-label', index === 0 ? 'Show assembly preview' : 'Show calendar pages');
      if (index === 0) {
        dot.classList.add('is-active');
      }
      dots.appendChild(dot);
      return dot;
    });

    dots.addEventListener('click', (event) => {
      const target = event.target;
      if (!target || !target.dataset || typeof target.dataset.index === 'undefined') {
        return;
      }
      const index = Number(target.dataset.index);
      track.scrollTo({
        left: track.clientWidth * index,
        behavior: 'smooth',
      });
    });

    track.addEventListener(
      'scroll',
      () => {
        requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          dotButtons.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
          });
          updateCarouselHeight(track, index);
        });
      },
      { passive: true }
    );

    track.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) {
          return;
        }
        event.preventDefault();
        track.scrollLeft += event.deltaY;
      },
      { passive: false }
    );

    carousel.appendChild(track);
    carousel.appendChild(dots);

    updateCarouselHeight(track, 0);
    assemblyImage.addEventListener('load', () => updateCarouselHeight(track, 0), { once: true });

    let hintTimeout = null;
    let hintCanceled = false;
    const cancelHint = () => {
      if (hintCanceled) {
        return;
      }
      hintCanceled = true;
      if (hintTimeout) {
        clearTimeout(hintTimeout);
      }
      slideAssembly.classList.remove('tpp-calendar-carousel__track--hint');
      slideGrid.classList.remove('tpp-calendar-carousel__track--hint');
    };

    track.addEventListener('scroll', cancelHint, { once: true, passive: true });
    track.addEventListener('pointerdown', cancelHint, { once: true });
    track.addEventListener('touchstart', cancelHint, { once: true, passive: true });
    track.addEventListener('wheel', cancelHint, { once: true, passive: true });

    hintTimeout = setTimeout(() => {
      if (hintCanceled) {
        return;
      }
      slideAssembly.classList.add('tpp-calendar-carousel__track--hint');
      slideGrid.classList.add('tpp-calendar-carousel__track--hint');

      slideAssembly.addEventListener(
        'animationend',
        () => {
          slideAssembly.classList.remove('tpp-calendar-carousel__track--hint');
        },
        { once: true }
      );

      slideGrid.addEventListener(
        'animationend',
        () => {
          slideGrid.classList.remove('tpp-calendar-carousel__track--hint');
        },
        { once: true }
      );
    }, 1500);

    return carousel;
  }

  function updateCarouselHeight(track, index) {
    const slide = track.children[index];
    if (!slide) {
      return;
    }
    const nextHeight = slide.offsetHeight;
    if (nextHeight) {
      track.style.height = `${nextHeight}px`;
    }
  }

  function parsePriceValue(text) {
    const value = String(text || '').replace(/[^0-9.]/g, '');
    return value ? Number(value) : NaN;
  }

  function logSavingsPercentage() {
    const priceEl = document.querySelector('div.gp-price.gp-decoration-g-text-1');
    const compareEl = document.querySelector('div.gp-price.gp-product-compare-price');
    const saveEl = document.querySelector('.save-percentage p');
    const saveContainer = saveEl ? saveEl.closest('.save-percentage') : null;

    function setSaveVisibility(isVisible) {
      if (!saveEl) {
        return;
      }
      saveEl.style.display = isVisible ? '' : 'none';
      if (saveContainer) {
        saveContainer.style.display = isVisible ? '' : 'none';
      }
    }

    if (!priceEl || !saveEl) {
      return;
    }

    if (!compareEl) {
      setSaveVisibility(false);
      return;
    }

    const price = parsePriceValue(priceEl.textContent);
    const comparePrice = parsePriceValue(compareEl.textContent);
    if (!Number.isFinite(price) || !Number.isFinite(comparePrice) || comparePrice <= 0 || comparePrice <= price) {
      setSaveVisibility(false);
      return;
    }

    const savingsPercentage = Math.floor(((comparePrice - price) / comparePrice) * 100);
    saveEl.textContent = `Save ${savingsPercentage}%`;
    setSaveVisibility(true);
    console.log(`Savings: ${savingsPercentage}%`);
  }

  function observePriceChanges() {
    const priceSelector = 'div.gp-price.gp-decoration-g-text-1';
    const priceEl = document.querySelector(priceSelector);

    if (!priceEl) {
      const waitObserver = new MutationObserver(() => {
        if (document.querySelector(priceSelector)) {
          waitObserver.disconnect();
          observePriceChanges();
        }
      });
      waitObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }

    const observer = new MutationObserver(() => {
      logSavingsPercentage();
    });
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    logSavingsPercentage();
  }

  observePriceChanges();
})();
